
import moment from 'moment';
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { Connection } from '@/types';
import DatePicker from '@/components/DatePicker.vue';
import EditEneaPracticeDialog from '@/components/connections/EditEneaPracticeDialog.vue';
import UtilsMixin from '@/mixins/UtilsMixin.vue';

moment.locale('it');

@Component({
  components: {
    DatePicker,
    EditEneaPracticeDialog,
  },
})
export default class ConnectionEneaPractice extends Mixins(UtilsMixin) {
  @Prop(Object) readonly connection!: Connection;

  loading = false
  editDialog = false

  get isDisabled() {
    return this.loading || !this.hasPermission('eneaPracticeDate.edit');
  }

  get eneaPracticeDate(): Date | null {
    return this.connection?.eneaPracticeDate ?? null;
  }

  get praticaEnea(): string {
    return this.connection?.praticaEnea ?? '';
  }

  get eneaPracticeDateString(): string | null {
    if (this.praticaEnea === 'na') return 'Non applicabile';
    return this.eneaPracticeDate
      && moment(this.eneaPracticeDate).isValid()
      ? moment(this.eneaPracticeDate).format('L')
      : null;
  }

  get linkClass(): string {
    // Se è disabilitato, ritorna il colore grigio senza puntatore
    if (this.isDisabled) return 'grey--text text--lighten-2';
    // Se la pratica ENEA è 'na', ritorna il colore grigio con puntatore
    if (this.praticaEnea === 'na') return 'link grey--text text--darken-2';

    // Se la data non è definita, ritorna il colore grigio con puntatore
    return this.eneaPracticeDateString
      ? 'link'
      : 'link grey--text text--lighten-2';
  }
  get columnClass(): string {
    if (this.praticaEnea === 'na') return 'grey lighten-3';
    if (this.eneaPracticeDate && this.praticaEnea === 'done') return 'green';
    return '';
  }

  get tooltipColor(): string {
    return '';
  }

  get tooltipText(): string {
    return 'Data pratica ENEA/GSE/Altro';
  }

  async onEdit() {
    // Non permette l'apertura del dialog durante il caricamento
    if (this.loading || this.isDisabled) return;

    console.log(`${this.constructor.name}: onEdit()`); // eslint-disable-line no-console

    // La connessione deve esistere per procedere
    if (this.connection) {
      // Seleziona la Connection prima di aprire il dialog
      this.loading = true;
      await this.$store.dispatch('selectConnection', { id: this.connection.id });
      this.editDialog = true;
      this.loading = false;
    }
  }
}

